import React, { useCallback } from 'react';
import ReactTable, { TableProps } from 'react-table';
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
} from '@material-ui/core';

import TrGroup from './TrGroup';
import NoData, { noDataPropsMapper } from './NoData';
import Loading from './Loading';
import TableHeader from './TableHeader';
import Pagination from './Pagination';

const NullComponent = () => null;

type Props<D> = Partial<TableProps<D>> & {
  count: number;
};

const MaterialTable = <D extends object>({
  count,
  ...props
}: Props<D>) => {
  const paginationPropsMapper = useCallback(() => ({
    count,
  }), [count]);

  return (
    <ReactTable
      TableComponent={MuiTable}
      TheadComponent={TableHead}
      TbodyComponent={TableBody}
      TrGroupComponent={TrGroup}
      TrComponent={TableRow}
      ThComponent={TableHeader}
      TdComponent={TableCell}
      TfootComponent={TableFooter}

      ExpanderComponent={NullComponent}
      AggregatedComponent={NullComponent}
      PivotValueComponent={undefined}
      PivotComponent={NullComponent}
      FilterComponent={NullComponent}
      PaginationComponent={Pagination}
      PreviousComponent={undefined}
      NextComponent={undefined}
      LoadingComponent={Loading}
      NoDataComponent={NoData}
      ResizerComponent={NullComponent}

      getPaginationProps={paginationPropsMapper}
      getNoDataProps={noDataPropsMapper}
      minRows={0}
      pages={0}

      {...props}
    />
  );
};

export default MaterialTable;
